import _ from 'lodash';

import { EventEmitter } from '@angular/core';

import template from './editTripWire.html';

/* @ngInject */
function EditTripWireController(
  $scope,
  $q,
  growl,
  EquipmentInfoService,
  EquipmentService,
  GroupService,
  GroupsButtonService,
  MapService
) {
  const vm = this;
  const { LatLng, SymbolPath, Polyline, MVCArray, LatLngBounds } = google.maps;
  const lat = 32;
  const lng = -97;
  const mapOptions = {
    center: new LatLng(lat, lng),
    zoom: 5,
  };
  const polyOptions = {
    strokeColor: '#D54937',
    strokeOpacity: 1,
    strokeWeight: 3
  };
  const markerIcon = {
    path: SymbolPath.CIRCLE,
    scale: 5,
    strokeWeight: 2,
    strokeColor: '#000000',
    fillColor: '#D54937',
    fillOpacity: 1
  };
  let tripwireMap;
  // Temp array to hold the current tripwire pair
  vm.tripwireEquipment = [];
  vm.equipmentModalInfo = {
    disableSaveButton: false
  };
  vm.groupList = [];

  vm.notifyChange = new EventEmitter();

  vm.startPointSelected = startPointSelected;
  vm.endPointSelected = endPointSelected;
  vm.tripwireNameBlank = tripwireNameBlank;
  vm.removeLastMarker = removeLastMarker;
  vm.addTripwire = addTripwire;
  vm.addTripWires = addTripWires;
  vm.clearTempTripwire = clearTempTripwire;
  vm.clearAndResetTempPolyline = clearAndResetTempPolyline;
  vm.redrawAllPolylines = redrawAllPolylines;
  vm.updateTripWire = updateTripWire;
  vm.updateSettings = updateSettings;
  vm.onFormFeedback = onFormFeedback;
  vm.triggerNotifyChange = triggerNotifyChange;

  vm.$onInit = () => {
    vm.clearTempTripwire();
    vm.poly = {};
    vm.selectedGroups = vm.newEquipment && _.size(vm.newEquipment.groups) ?
      angular.copy(vm.newEquipment.groups) : [];

  };
  vm.$postLink = () => {
    createEditTripWireMap();

    generateFormInfo();

    $scope.$watch(() => vm.updatedOrg, () => {
      const id = vm.updatedOrg;
      if (id) {
        GroupService.getGroupByOrg(id).then(({ body }) => {
          vm.groupList = [body];
        }).catch((error) => {
          growl.error(error, { title: 'Could not get groups for selected organization' });
        });
      } else {
        GroupService.getGroupTree().then(({ data }) => {
          vm.groupList = data;
        });
      }
    });
  };
  vm.$onDestroy = () => {
    // Clean up listeners for all tripwires in memory
    [...vm.tripwireEquipment, vm.tempTripwire].forEach((equipment) => {
      if (equipment?.startMarker?._dragListener) {
        google.maps.event.removeListener(equipment.startMarker._dragListener);
        equipment.startMarker._dragListener = null;
      }
      if (equipment?.endMarker?._dragListener) {
        google.maps.event.removeListener(equipment.endMarker._dragListener);
        equipment.endMarker._dragListener = null;
      }
    });

    MapService.unsetMarkers([...vm.allMarkers, vm.tempPolyline]);
    if (vm.tempTripwire.startMarker) {
      vm.tempTripwire.startMarker.setMap(null);
    }
    if (vm.tempTripwire.endMarker) {
      vm.tempTripwire.endMarker.setMap(null);
    }
    MapService.destroyGoogleMaps('#tripwire-location');
  };


  function startPointSelected() {
    return _.get(vm.tempTripwire, 'settings.start.lat', '') !== '';
  }

  function endPointSelected() {
    return _.get(vm.tempTripwire, 'settings.end.lat', '') !== '';
  }
  function tripwireNameBlank() {
    return vm.tempTripwire.name === '' || _.isUndefined(vm.tempTripwire.name);
  }

  function removeLastMarker() {
    const path = vm.tempPolyline.getPath();
    // if the start point for the current temp poly isn't set, don't delete - to prevent deleting any previous markers
    if (vm.startPointSelected()) {
      // if the polyline path is not empty, remove the last polyline point
      path.pop();
      const { start, end } = vm.tempTripwire.settings;
      // check the last point of the temp tripwire pair array and remove it
      if (end.lat === '') {
        // remove the start point and its marker
        start.lat = '';
        start.lng = '';
        const tempStartMarker = vm.tempTripwire.startMarker;
        // Remove drag listener if exists
        if (tempStartMarker?._dragListener) {
          google.maps.event.removeListener(tempStartMarker._dragListener);
          tempStartMarker._dragListener = null;
        }
        // Remove the marker from the map - does not delete it
        tempStartMarker.setMap(null);
        path.clear();
        vm.tempTripwire.startMarker = '';
      } else {
        // remove the end point and its marker
        end.lat = '';
        end.lng = '';
        const tempEndMarker = vm.tempTripwire.endMarker;
        // Remove drag listener if exists
        if (tempEndMarker?._dragListener) {
          google.maps.event.removeListener(tempEndMarker._dragListener);
          tempEndMarker._dragListener = null;
        }
        // Remove the marker from the map - does not delete it
        tempEndMarker.setMap(null);
        vm.tempTripwire.endMarker = '';
      }
      vm.disableAddLatLng = false;
    }
  }

  function addTripwire() {
    if (!vm.tripwireNameBlank()) {
      vm.disableAddLatLng = false;
      // save the current polyline path and reference to the polyline to the temp tripwire
      const path = vm.tempPolyline.getPath();
      vm.tempTripwire.polyPath = path;
      vm.tempTripwire.line = vm.tempPolyline;
      // push the temp tripwire pair to the main tripwire holder
      vm.tripwireEquipment.push(vm.tempTripwire);
      // clear the temp tripwire
      vm.clearTempTripwire();
      // clear the temp polyline so it is redrawn with the rest of the polylines in the tripwireEquipment array
      vm.clearAndResetTempPolyline();
      // update the style of all polylines and markers in tripwireEquipment
      vm.redrawAllPolylines();
    }
  }

  function addTripWires(tripwireEquipment) {
    vm.selectedGroups = GroupsButtonService.rebuildSelectedGroups();
    if (vm.tripwireEquipment.length <= 0) {
      growl.error('Please save a tripwire path', {
        disableCloseButton: false
      });
    } else if (vm.selectedGroups.length === 0) {
      growl.error('Please select a group', {
        disableCloseButton: false
      });
    } else {
      let growlMessage = growl.info('Saving Changes..', {
        disableCloseButton: true
      });

      vm.equipmentModalInfo.disableSaveButton = true;

      const tripWirePromises = [];
      _.forEach(tripwireEquipment, (equipment) => {
        // add to allMarkers for cleanup later
        vm.allMarkers = [...vm.allMarkers, equipment.line, equipment.startMarker, equipment.endMarker];
        // delete the google maps elements because angular copy does not do DOM elements
        delete equipment.line;
        delete equipment.startMarker;
        delete equipment.endMarker;
        delete equipment.polyPath;

        const eqObject = angular.copy(equipment);

        // add selected groups
        eqObject.groups = _.map(vm.selectedGroups, 'id');

        // add selected organization
        eqObject.org = vm.updatedOrg;

        // set the rcu for each tripwire
        eqObject.rcu = vm.currentRcuId;

        // Calculate centerpoint between start and end using helper
        const { latitude, longitude } = calculateCenterPoint(eqObject.settings.start, eqObject.settings.end);
        if (angular.isDefined(latitude) && angular.isDefined(longitude)) {
          eqObject.settings.latitude = latitude;
          eqObject.settings.longitude = longitude;
        }

        tripWirePromises.push(EquipmentInfoService.addEquipment(eqObject));
      });

      $q.all(tripWirePromises)
        .then((newTrips) => {
          growlMessage.destroy();
          growlMessage = growl.success('Saved successfully...');
          vm.equipmentModalInfo.disableSaveButton = false;
          vm.close(newTrips);
        })
        .catch((res) => {
          growlMessage.destroy();
          growlMessage = growl.error(res.error, {
            title: 'Error while saving:'
          });
        });
    }
  }

  function clearTempTripwire() {
    // Remove drag listeners if markers exist
    if (vm.tempTripwire?.startMarker?._dragListener) {
      google.maps.event.removeListener(vm.tempTripwire.startMarker._dragListener);
      vm.tempTripwire.startMarker._dragListener = null;
    }
    if (vm.tempTripwire?.endMarker?._dragListener) {
      google.maps.event.removeListener(vm.tempTripwire.endMarker._dragListener);
      vm.tempTripwire.endMarker._dragListener = null;
    }
    vm.tempTripwire = {
      name: '',
      polyPath: '',
      startMarker: '',
      endMarker: '',
      settings: {
        start: {
          lat: '',
          lng: ''
        },
        end: {
          lat: '',
          lng: ''
        },
      },
      equipmentType: 'tripwires'
    };

    generateFormInfo();
  }

  function clearAndResetTempPolyline() {
    // removes the polyline from the map but does not delete it
    vm.tempPolyline.setMap(null);
    // deletes the poly line
    vm.tempPolyline = null;
    vm.tempPolyline = new Polyline(polyOptions);
    vm.tempPolyline.setMap(tripwireMap);
  }

  // Helper to create polyline and markers, and attach drag listeners
  function createTripWireGraphics(equipment, mapRef) {
    // Create polyline
    let polyPath = equipment.polyPath;
    if (!polyPath) {
      const start = new LatLng(equipment.settings.start.lat, equipment.settings.start.lng);
      const end = new LatLng(equipment.settings.end.lat, equipment.settings.end.lng);
      polyPath = new MVCArray([start, end]);
      equipment.polyPath = polyPath;
    }
    if (!equipment.line) {
      equipment.line = new Polyline({ path: polyPath });
    }
    equipment.line.setOptions({
      strokeColor: '#7CD646',
      strokeOpacity: 1,
      strokeWeight: 3
    });
    equipment.line.setMap(mapRef);
    // Create start marker if missing
    if (!equipment.startMarker) {
      const startMarker = new MapService.Marker(mapRef, {}, {
        ...markerIcon,
        fillColor: '#1CA105'
      }, false, {
        position: polyPath.getAt(0),
        title: `${equipment.name} start`,
        draggable: true,
      });
      equipment.startMarker = startMarker;
    }
    // Create end marker if missing
    if (!equipment.endMarker) {
      const endMarker = new MapService.Marker(mapRef, {}, {
        ...markerIcon,
        fillColor: '#1CA105'
      }, false, {
        position: polyPath.getAt(1),
        title: `${equipment.name} end`,
        draggable: true,
      });
      equipment.endMarker = endMarker;
    }

    // Always attach drag listeners to keep polyline and settings in sync
    attachDragListener(
      equipment.startMarker,
      0,
      polyPath,
      (newPos) => {
        equipment.settings.start.lat = newPos.lat();
        equipment.settings.start.lng = newPos.lng();
      }
    );
    attachDragListener(
      equipment.endMarker,
      1,
      polyPath,
      (newPos) => {
        equipment.settings.end.lat = newPos.lat();
        equipment.settings.end.lng = newPos.lng();
      }
    );

    // Update marker style
    const newMarkerOptions = {
      title: equipment.name,
      icon: {
        path: SymbolPath.CIRCLE,
        scale: 5,
        strokeWeight: 2,
        strokeColor: '#000000',
        fillColor: '#1CA105',
        fillOpacity: 1
      }
    };
    equipment.startMarker.setOptions(newMarkerOptions);
    equipment.endMarker.setOptions(newMarkerOptions);
  }

  function redrawAllPolylines() {
    _.forEach(vm.tripwireEquipment, (equipment) => {
      createTripWireGraphics(equipment, tripwireMap);
      vm.allMarkers.push(equipment.line);
    });
  }

  // Helper to calculate the centerpoint between start and end using LatLngBounds
  function calculateCenterPoint(start, end) {
    if (start?.lat !== '' && start?.lng !== '' && end?.lat !== '' && end?.lng !== '') {
      const startLatLng = new LatLng(parseFloat(start.lat), parseFloat(start.lng));
      const endLatLng = new LatLng(parseFloat(end.lat), parseFloat(end.lng));
      const bounds = new LatLngBounds();
      bounds.extend(startLatLng);
      bounds.extend(endLatLng);
      const center = bounds.getCenter();
      return { latitude: center.lat(), longitude: center.lng() };
    }
    return { latitude: undefined, longitude: undefined };
  }

  function updateTripWire(equip) {
    let growlMessage = growl.info('Saving Changes..', {
      disableCloseButton: true
    });

    vm.equipmentModalInfo.disableSaveButton = true;

    // delete the google maps elements because angular copy does not do DOM elements
    delete equip.line;
    delete equip.startMarker;
    delete equip.endMarker;

    const eqObject = angular.copy(equip);

    // Calculate centerpoint between start and end using helper
    const { latitude, longitude } = calculateCenterPoint(eqObject.settings.start, eqObject.settings.end);
    if (angular.isDefined(latitude) && angular.isDefined(longitude)) {
      eqObject.settings.latitude = latitude;
      eqObject.settings.longitude = longitude;
    }

    const bodyObject = {
      updates: {
        name: eqObject.name,
        equipmentType: eqObject.equipmentType,
        settings: eqObject.settings
      }
    };
    EquipmentService.editEquipment(eqObject.id, bodyObject)
      .then((success) => {
        growlMessage.destroy();
        growlMessage = growl.success('Saved successfully...');

        vm.equipmentModalInfo.disableSaveButton = false;
        const equipment = success.data[0];
        EquipmentInfoService.updateEquipment(equipment);
        vm.close(equipment);
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, {
          title: 'Error while saving:'
        });
        vm.equipmentModalInfo.disableSaveButton = false;
      });
  }

  function createEditTripWireMap() {
    // Map for the Laser setup
    tripwireMap = new MapService.Map(document.getElementById('tripwire-location'), 'admin-tripwire-modal', mapOptions);
    vm.allMarkers = [];
    // Add a listener for the click event
    google.maps.event.addListener(tripwireMap, 'click', addLatLng);
    if (vm.editing) {
      vm.tempTripwire = angular.copy(vm.newEquipment);
      // variable to prevent adding more than two map markers at a time
      vm.disableAddLatLng = true;
      const { start, end } = vm.tempTripwire.settings;
      vm.poly = {};
      vm.poly.start = new LatLng(start.lat, start.lng);
      vm.poly.end = new LatLng(end.lat, end.lng);
      vm.poly.path = new MVCArray([vm.poly.start, vm.poly.end]);
      // create start and end markers using forEach
      [
        {
          key: 'start',
          fillColor: '#1CA105',
        },
        {
          key: 'end',
          fillColor: '#D54937',
        },
      ].forEach(({ key, fillColor }, idx) => {
        markerIcon.fillColor = fillColor;
        const marker = new MapService.Marker(tripwireMap, {}, markerIcon, false, {
          position: vm.poly[key],
          title: `${vm.tempTripwire.name} ${key}`,
          draggable: true,
        });
        attachDragListener(
          marker,
          idx,
          vm.poly.path,
          (newPos) => {
            vm.poly[key] = newPos;
            vm.tempTripwire.settings[key].lat = newPos.lat();
            vm.tempTripwire.settings[key].lng = newPos.lng();
          }
        );
        vm.tempTripwire[`${key}Marker`] = marker;
        vm.allMarkers.push(marker);
      });
      setTimeout(() => MapService.fitZoomMap(tripwireMap, vm.allMarkers), 0);
      vm.poly.line = new Polyline({
        path: vm.poly.path,
        strokeColor: '#7CD646',
        strokeOpacity: 1,
        strokeWeight: 4,
      });
      vm.poly.line.setMap(tripwireMap);
      vm.tempPolyline = vm.poly.line;
    } else {
      // variable to prevent adding more than two map markers at a time
      vm.disableAddLatLng = false;
      // Temp poly line to show the current tripwire pair that will be added to the tripwireEquipment array
      vm.tempPolyline = new Polyline(polyOptions);
      vm.tempPolyline.setMap(tripwireMap);
    }
  }

  // Helper to attach drag listener and store reference
  function attachDragListener(markerObj, idx, path, updateSettingsFn) {
    if (markerObj._dragListener) {
      google.maps.event.removeListener(markerObj._dragListener);
    }
    markerObj._dragListener = markerObj.addListener('position_changed', () => {
      const newPos = markerObj.getPosition();
      path.setAt(idx, newPos);
      $scope.$evalAsync(() => {
        updateSettingsFn(newPos);
        vm.triggerNotifyChange();
      });
    });
  }

  function addLatLng(event) {
    $scope.$apply(() => {
      if (!vm.disableAddLatLng) {
        const path = vm.tempPolyline.getPath();
        // Because path is an MVCArray, we can simply append a new coordinate and it will automatically appear.
        path.push(event.latLng);
        const { start, end } = vm.tempTripwire.settings;
        markerIcon.fillColor = start.lat === '' ? '#1CA105' : '#D54937';
        const { lat: latitude, lng: longitude } = event.latLng.toJSON();
        // Add a new marker at the new plotted point on the polyline.
        const marker = new MapService.Marker(
          tripwireMap,
          { settings: { latitude, longitude } },
          markerIcon,
          false,
          { position: event.latLng, draggable: true }
        );
        const markerLat = marker.getPosition().lat();
        const markerLon = marker.getPosition().lng();
        if (start.lat === '') {
          start.lat = markerLat;
          start.lng = markerLon;
          vm.tempTripwire.startMarker = marker;
          attachDragListener(
            marker,
            0,
            path,
            (newPos) => {
              vm.tempTripwire.settings.start.lat = newPos.lat();
              vm.tempTripwire.settings.start.lng = newPos.lng();
            }
          );
        } else {
          end.lat = markerLat;
          end.lng = markerLon;
          vm.tempTripwire.endMarker = marker;
          attachDragListener(
            marker,
            1,
            path,
            (newPos) => {
              vm.tempTripwire.settings.end.lat = newPos.lat();
              vm.tempTripwire.settings.end.lng = newPos.lng();
            }
          );
          // prevent adding a third point
          vm.disableAddLatLng = true;
        }
        vm.allMarkers.push(marker);
        vm.triggerNotifyChange();
      }
    });
  }

  function generateFormInfo() {
    vm.model = vm.tempTripwire.settings;
    vm.formOptions = {
      title: 'Settings',
      buildFromSchema: false,
    };
  }

  function updateSettings(update) {
    const { model } = update;
    $scope.$evalAsync(() => {
      // keep original reference so we don't cause an infinite change loop
      model !== vm.model && angular.copy(model, vm.model);
      updateMap();
    });
  }

  function updateMap() {
    const { start, end } = vm.tempTripwire?.settings || {};

    [start, end].forEach((point, idx) => {
      if (_.get(point, 'lat', '') === '' || _.get(point, 'lng', '') === '') {
        return;
      }
      const position = new LatLng(point.lat, point.lng);
      const whichMarker = idx === 0 ? 'startMarker' : 'endMarker';
      let marker = vm.tempTripwire[whichMarker];
      if (!marker) {
        const fillColor = idx === 0 ? '#1CA105' : '#D54937';
        markerIcon.fillColor = fillColor;
        marker = new MapService.Marker(
          tripwireMap,
          { settings: { latitude: point.lat, longitude: point.lng } },
          markerIcon,
          false,
          { position, draggable: true }
        );

        vm.tempTripwire[whichMarker] = marker;

        vm.allMarkers.push(marker);
        attachDragListener(
          marker,
          idx,
          vm.tempPolyline.getPath(),
          (newPos) => {
            const pointToUpdate = idx === 0 ? vm.tempTripwire.settings.start : vm.tempTripwire.settings.end;
            pointToUpdate.lat = newPos.lat();
            pointToUpdate.lng = newPos.lng();
          }
        );
      }

      if (!position.equals(marker.getPosition())) {
        marker.setPosition(position);
      }
    });
  }

  function onFormFeedback(event) {
    if (event.type === 'isValid') {
      $scope.$apply(() => {
        vm.equipmentModalInfo.disableSaveButton = !event.data;
      });
    }
  }

  function triggerNotifyChange() {
    vm.notifyChange.emit({
      model: vm.model
    });
  }
}

export default {
  name: 'editTripWire',
  template,
  controller: EditTripWireController,
  bindings: {
    editing: '<',
    currentRcuId: '<',
    newEquipment: '<',
    isValidJson: '<',
    editGroups: '<',
    close: '<',
    dismiss: '<'
  }
};
